import Info from './Info';
import Field from './Field';

export default {
  Info,
  Field,
};
